import { render, staticRenderFns } from "./infoCourse.vue?vue&type=template&id=4eb7d27e"
import script from "./infoCourse.vue?vue&type=script&lang=js"
export * from "./infoCourse.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports